import { getQuarter } from "Shared/Functions/DateMath";
import { ExtendedPodResData, PodResData } from "Shared/Globals";

const convertTeamData = (data: PodResData[]) => {
    const groups = new Map<string, ExtendedPodResData>();

    data.forEach((item) => {
        const groupKey = `${item.text}\u0000${item.podId}`;
        let group = groups.get(groupKey);

        if (!group) {
            group = {
                teamname: item.text,
                podId: item.podId,
                year: item.day.getFullYear(),
                quarter: getQuarter(item.day),
                children: []
            };
            groups.set(groupKey, group);
        }

        if (item.id) {
            group.children?.push(item.id);
        }
    });

    if (groups.size > 0) {
        return Array.from(groups.values());
    }

    return null;
}

export const mapTeamData = (q1: PodResData[], q2: PodResData[]) => {
    const q1Data = convertTeamData(q1);
    const q2Data = convertTeamData(q2);
    let arr: ExtendedPodResData[] = [];

    if (q1Data && q2Data) arr = [...q1Data, ...q2Data];
    else if (q1Data) arr = q1Data;
    else if (q2Data) arr = q2Data;

    arr.sort((a, b) => (a.quarter as number) - (b.quarter as number));
    return arr.sort((a, b) => {
        let na = a.teamname.toLowerCase();
        let nb = b.teamname.toLowerCase();
        if (na < nb) return -1;
        if (na > nb) return 1;
        return 0;
    })
}